// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d6334f8","892":"5379daee"}[chunkId] + ".chunk.js";
};